module.exports = __webpack_public_path__ + "img/sj01.e272a5e8.png";